import { ProductType } from '@inter-ikea-storageone/range';
import { SelectedMenu, SelectedMenuProductList } from 'rangeConfig/@types';
import addInteriorSuggestion from 'rangeConfig/ivar/behaviors/addInteriorSuggestion';
import addProduct from 'rangeConfig/shared/behaviors/addProduct';
import addToTarget from 'rangeConfig/shared/behaviors/addToTarget';
import deleteSelectedEntity from 'rangeConfig/shared/behaviors/deleteSelectedEntity';
import hideDoors from 'rangeConfig/shared/behaviors/hideDoors';
import {
  matchDepth,
  matchHeight,
  matchWidth
} from 'rangeConfig/shared/filters/selectedMenuProductFilters';
import platform from 'rangeConfig/shared/utils/platform';
import DimensionsLabel from 'rangeConfig/shared/widgets/DimensionsLabel';
import { noneOptionForInteriorSuggestions } from 'rangeConfig/shared/widgets/interiorSuggestions/noneOptionForInteriorSuggestions';

const interiorSuggestions: SelectedMenuProductList = {
  id: 'frames-selected-menu-interior-suggestions',
  title: 'storageone.selectedMenuInteriorsCombinationsMenuTitle',
  cardsTitle: '',
  cardsSubtitle: '',
  productThumbToolTip: 'name',
  behaviors: {
    productClicked: [hideDoors, addInteriorSuggestion],
    productDropped: [hideDoors, addInteriorSuggestion]
  },
  productTypes: [ProductType.IVAR_INTERIOR_SUGGESTION],
  productFilters: [matchWidth, matchDepth, matchHeight],
  noneOption: noneOptionForInteriorSuggestions
};

const interiors = {
  id: 'section-selected-menu-interiors',
  title: 'storageone.productListInteriorsTitle',
  cardsSubtitle: 'typeName, communicatedSizeText',
  filters: [],
  behaviors: {
    productClicked: [addToTarget],
    productDropped: [addProduct]
  },
  productTypes: [
    ProductType.IVAR_SHELF_PINE,
    ProductType.IVAR_SHELF_METAL,
    ProductType.IVAR_SHELF_FELT,
    ProductType.IVAR_BOTTLE_RACK,
    ProductType.IVAR_DRAWER_PINE,
    ProductType.IVAR_TABLE,
    ProductType.IVAR_CORNER_SHELF
  ],
  productFilters: [matchWidth, matchDepth]
};

const widgets = {
  desktop: [
    {
      id: 'display-size',
      title: 'storageone.sizeFilterLabel',
      component: DimensionsLabel
    },
    interiorSuggestions,
    interiors
  ],
  mobile: [interiorSuggestions, interiors]
};

const selectedMenu: SelectedMenu = {
  menuTitle: 'storageone.productListSectionsTitle',
  behaviors: {
    productDeleted: [deleteSelectedEntity]
  },
  content: widgets[platform]
};

export default selectedMenu;
